// extracted by mini-css-extract-plugin
export default {"emptyState":"topicsEmptyState_emptyState__qlEAF","icon":"topicsEmptyState_icon__X6Ujr","title":"topicsEmptyState_title__p4sH3","subtitle":"topicsEmptyState_subtitle__6pHuD"};